module.exports = __webpack_public_path__ + "static/media/phone-icon.b72d46c8.svg";